import { render, staticRenderFns } from "./dprolstcolitem.vue?vue&type=template&id=0c12ee73&scoped=true"
import script from "./dprolstcolitem.vue?vue&type=script&lang=js"
export * from "./dprolstcolitem.vue?vue&type=script&lang=js"
import style0 from "./dprolstcolitem.vue?vue&type=style&index=0&id=0c12ee73&prod&lang=scss&scoped=true"
import style1 from "./dprolstcolitem.vue?vue&type=style&index=1&id=0c12ee73&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c12ee73",
  null
  
)

export default component.exports